module.exports = __webpack_public_path__ + "static/media/graduation.a59660fc.jpg";